export function EscRegExpression(breakChars) {
  if (breakChars == null) return breakChars;

  return breakChars.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
